<template>
  <div>
    <Input
      label="IP"
      id="ip-address"
      v-model="form.ip"
      placeholder="Enter IP"
      :state="validateState('ip')"
    />

    <Input
      label="Username"
      id="username"
      v-model="form.username"
      placeholder="Enter Username"
      :state="validateState('username')"
    />

    <Input
      label="Password"
      id="password"
      v-model="form.password"
      placeholder="Enter Password"
      :state="validateState('password')"
    />
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExecuteDeviceServer',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
  },
  data() {
    return {
      form: {
        ip: '',
        username: '',
        password: '',
      },
    }
  },
  validations: {
    form: {
      ip: {
        required,
      },
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        host: this.form.ip,
        host_user: this.form.username,
        host_pass: this.form.password,
        become: 1,
        port: 22,
      }

      ApiService.post(
        `ansible/playbook/${this.$route.params.id}/execute`,
        params
      )
        .then(() => {
          this.$emit('resetDetailForm', true)
          setTimeout(() => {
            this.$generateToast(this, 'success', this.$t('global.successful'))
          }, 200)
        })
        .catch((err) => {
          this.$emit('resetDetailForm', false)
          setTimeout(() => {
            this.$generateToast(this, 'danger', err.message, true)
          }, 200)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>
